import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TenantHttpClientService } from './tenant-http-client.service';
import { Observable, catchError, of } from 'rxjs';

const WORLDPAYEXPRESS_SURCHARGING_FEATURE = {
  applicationId: 'arc-quantum',
  featureId: 'arc-feature-worldpayexpress-surcharging',
};

@Injectable({
  providedIn: 'root',
})
export class WorldpayExpressFeatureCheckService {
  private tenantHttpClientService: TenantHttpClientService = inject(
    TenantHttpClientService,
  );

  private getIsWorldpayExpressEnabled(): Observable<boolean> {
    return this.tenantHttpClientService
      .getFeatureIsEnabled(
        WORLDPAYEXPRESS_SURCHARGING_FEATURE.applicationId,
        WORLDPAYEXPRESS_SURCHARGING_FEATURE.featureId,
      )
      .pipe(
        catchError((error) => {
          console.error('Error checking Worldpay Express feature:', error);
          // Return false as fallback when API fails
          return of(false);
        }),
      );
  }

  /**
   * Signal that indicates whether Worldpay Express surcharging feature is enabled.
   *
   * This signal executes the API call to check the feature flag during service construction
   * and caches the result internally for efficient consumer usage. The signal provides
   * reactive access to the feature state without requiring manual subscription management.
   *
   * @remarks
   * - API call is made once during service initialization via toSignal()
   * - Result is cached automatically by Angular's signal implementation
   * - If API call fails, the signal will remain `false` (safe fallback)
   * - Initial value is `false` until the API response is received
   * - Errors are caught and logged, preventing service construction failure
   */
  isWorldpayExpressEnabled = toSignal(this.getIsWorldpayExpressEnabled(), {
    initialValue: false,
  });
}
